<template>
  <div :id="id" :class="['radio', { 'radio--active' : checked }, getTheme]" @click="onClick">
    <div class="radio__circle"></div>
    <div class="radio__text">{{ item.Text }}</div>
  </div>
</template>

<script>
export default {
  name: 'nt-form-radio',
  props: {
    item: {
      type: Object,
      required: true,
      validator(val) {
        return Object.hasOwnProperty.call(val, 'Text') &&
               Object.hasOwnProperty.call(val, 'Value')
      }
    },
    valueSelected: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  created() {
    if (this.valueSelected === this.item.Value.toString()) {
      this.$emit('onSelect', this.item)
    }
  },
  computed: {
    getTheme() {
      return `radio--${this.theme}`
    },
    checked() {
      return this.$parent.$data.selected === this.$props.item.Value
    }
  },
  methods: {
    onClick() {
      this.$emit('onSelect', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .radio {
    $container: &;
    display: flex;
    align-items: center;
    margin-bottom: 2px;

    &:hover {
      cursor: pointer;
    }

    &__circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      padding: 2px;
      margin-right: 14px;
      border-radius: 100%;
      border: 1px solid #CCC;
    }

    &__text {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -1px;
      // font-weight: normal;
      white-space: nowrap;
    }

    &--active {
      #{$container}__circle {
        &::before {
          content: '';
          width: 100%;
          height: 100%;
          border-radius: 100%;
          background: #9ddda9;
        }
      }
    }

    &--small {
      #{$container}__circle {
        width: 16px;
        height: 16px;
      }

      #{$container}__text {
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
</style>

